import { render, staticRenderFns } from "./RsMembers.vue?vue&type=template&id=0b60a223&scoped=true&"
import script from "./RsMembers.vue?vue&type=script&lang=js&"
export * from "./RsMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60a223",
  null
  
)

export default component.exports